export const baseUrl = 'https://bms.qwertytech.ge/api';
